/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.com/docs/use-static-query/
 */

import React from "react"
import { Script } from "gatsby"
import PropTypes from "prop-types"
// import { useStaticQuery, graphql } from "gatsby"
import UrlJoin from "url-join"

import { useSiteMetadata } from "../hooks/use-site-metadata"

const SEO = ({ title, description, postDate, postUpdate, imagePath, twitter, noIndex, location }) => {
  const site = useSiteMetadata()
  const metaDescription = description || site?.description
  const pageTitle = `${title} | ${site?.title}` || site?.title
  const twitterID = twitter || site?.defaultTwitter //@なしのID
  const twitterCreator = twitterID ? "@" + twitterID : `` //@をつけたID
  const twitterImage = imagePath ? UrlJoin(site.siteUrl, imagePath) : "/img/title.jpg"
  // const url = `${site.siteMetadata?.siteUrl}${location.pathname || ``}`
  //メモ:lang="ja"はgatsby-ssrに記載：headではなくhtmlタグに書く必要があるため

  //構造化マークアップ
  const jsonLd = {
    "@context": "http://schema.org",
    "@type": "Article",
    "name": title,
    "author": {
      "@type": "Person",
      "name": "Ultra-Noob"
    },
    "datePublished": postDate || "",
    "dateModified": postUpdate || "",
    "image": twitterImage,
  }

  return (
    <>
      <title>{pageTitle}</title>
      <meta name="description" content={metaDescription} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:type" content="website" />
      <meta property="og:image" content={twitterImage} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:creator" content={twitterCreator} />
      <meta name="twitter:title" content={pageTitle} />
      <meta name="twitter:description" content={metaDescription} />
      <meta name="twitter:image" content={twitterImage}/>
      {/* <meta name="twitter:url" content={url} /> */}
      <Script type="application/ld+json">{JSON.stringify(jsonLd)}</Script>
      {
        noIndex ? <meta name="robots" content="noindex" /> : null
      }
    </>
  )
}

SEO.defaultProps = {
  lang: `ja`,
  meta: [],
  description: ``,
  location: ``
}

SEO.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired,
  location: PropTypes.object.isRequired,
}

export default SEO
